import { useDeferredValue, useState } from 'react';
import type { TreeTag } from '#domains/tags';
import { TreeTagsFilterContext } from './context';
import { searchTreeTags } from './utils';

type Props = {
  expanded?: boolean;
  tags: TreeTag[];
} & React.PropsWithChildren;

export const TreeTagsSearchProvider = ({
  tags,
  children,
  expanded = true
}: Props) => {
  const [queryString, setQueryString] = useState<string>('');
  const [selectedIds, setSelectedIds] = useState<string[]>([]);

  // Defer the expensive filtering operation
  const deferredQueryString = useDeferredValue(queryString);

  const filteredTags = searchTreeTags({
    tags,
    queryString: deferredQueryString,
    expanded
  });

  const value = {
    expanded,
    filteredTags,
    queryString,
    selectedIds,
    setQueryString,
    setSelectedIds
  };

  return (
    <TreeTagsFilterContext.Provider value={value}>
      {children}
    </TreeTagsFilterContext.Provider>
  );
};
